import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { dropsealOption } from "./defaults";
import Choices from "../Choices";
import { Image } from "cloudinary-react";
import PleaseNote from "../PleaseNote";
import Alert from "@mui/material/Alert";
import useDropsealSelector from "./useDropsealSelector";

function PivotDropsealAccordian() {
  const { handleClick, panelWidth, dropseal } = useDropsealSelector();

  return (
    <ReusableAccordian
      accordionName="dropseal"
      heading="Drop Seal"
      secondaryHeading="Add a Drop Seal"
      colOrRow="col"
    >
      {panelWidth > 90 ? (
        <Alert severity="error">
          Drop Seal not available when panel width is greater than 90 inches
        </Alert>
      ) : (
        <>
          <PleaseNote notes="A drop seal is a weatherstripping device at the bottom of the door that automatically descends when the door is closed, preventing drafts and enhancing insulation." />

          <div
            onClick={() => handleClick(dropsealOption.label)}
            style={{ paddingBottom: 40 }}
          >
            <Choices
              label={dropsealOption.label}
              variant={
                dropsealOption.label === dropseal ? "filled" : "outlined"
              }
              checkMark={dropsealOption.label === dropseal}
              wide={true}
            />
          </div>

          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId="/Dropseal/dropseal_v2"
          />
        </>
      )}
    </ReusableAccordian>
  );
}

export default memo(PivotDropsealAccordian);
